import { type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';

import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

function ConfirmDialog({
    title,
    message,
    body,
    onResolve,
}: {
    title: string;
    message: string;
    body?: ReactNode;
    onResolve: (value: boolean) => void;
}) {
    return (
        <Dialog open onOpenChange={(open) => !open && onResolve(false)}>
            <DialogContent showCloseButton={false}>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                <p className="text-sm text-foreground">{message}</p>
                {body}
                <DialogFooter>
                    <Button className="w-[100px]" onClick={() => onResolve(true)}>
                        Oui
                    </Button>
                    <Button className="w-[100px]" variant="outline" onClick={() => onResolve(false)}>
                        Non
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export const confirmPopup = ({
    title,
    message,
    body,
}: {
    title: string;
    message: string;
    // Optional rich content rendered under the message (e.g. a before/after summary of the change).
    body?: ReactNode;
}) => {
    return new Promise<boolean>((resolve) => {
        const container = document.createElement('div');
        document.body.appendChild(container);
        const root = createRoot(container);

        function handleResolve(value: boolean) {
            root.unmount();
            container.remove();
            resolve(value);
        }

        root.render(<ConfirmDialog title={title} message={message} body={body} onResolve={handleResolve} />);
    });
};
